import React, { useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config';

const getAdminToken = () => localStorage.getItem('adminKey') || '';

const AdminLEDButtons = ({ title, events }) => {
  const [status, setStatus] = useState('');

  const sendEvent = async (event) => {
    try {
      const payload = {
        type: event.type,
        duration: event.duration,
        eventName: event.eventName,
      };
      if (event.tickers) payload.tickers = event.tickers;
      if (event.changePercent != null) payload.changePercent = event.changePercent;

      await axios.post(`${API_BASE_URL}/api/admin/events/broadcast`, payload, {
        headers: { 'x-admin-token': getAdminToken() }
      });
      setStatus(`Sent: ${event.label}`);
      setTimeout(() => setStatus(''), 2000);
    } catch (error) {
      setStatus(`Error: ${error.response?.data?.error || error.message}`);
      setTimeout(() => setStatus(''), 3000);
    }
  };

  return (
    <div style={{
      background: '#1a1a2e',
      borderRadius: '8px',
      padding: '12px',
      marginTop: '16px',
      border: '1px solid #333'
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '8px'
      }}>
        <h4 style={{
          margin: 0,
          fontSize: '13px',
          color: '#a5b4fc',
          fontWeight: 600
        }}>
          {title || 'LED Events'}
        </h4>
        {status && (
          <span style={{
            fontSize: '11px',
            color: status.startsWith('Error') ? '#ef9a9a' : '#a5d6a7',
            fontStyle: 'italic'
          }}>
            {status}
          </span>
        )}
      </div>
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '4px'
      }}>
        {events.map((event, i) => (
          <button
            key={i}
            onClick={() => sendEvent(event)}
            title={`${event.type} (${event.duration}s)`}
            style={{
              padding: '4px 8px',
              border: 'none',
              borderRadius: '4px',
              background: event.color || '#555',
              color: ['#ffd700', '#ffeb3b', '#ffc107', '#e6c200', '#ffab00'].includes(event.color) ? '#000' : '#fff',
              fontWeight: 600,
              fontSize: '11px',
              cursor: 'pointer',
              lineHeight: '1.3',
              whiteSpace: 'nowrap'
            }}
          >
            {event.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default AdminLEDButtons;
